import React from 'react';
import { Flex, IconButton, InputV2 } from '@withjoy/joykit';
import { StyledFormControl, StyledSaveButton, styles } from './EditGuestCount.styles';
import { pxToRem } from '@withjoy/joykit/theme';
import { Close } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';
import type { useRegistryGiftCounts } from '@apps/registry/common/components/RegistryGiftCounts/RegistryGiftCounts.controller';

interface EditGuestCountProps {
  formik: ReturnType<typeof useRegistryGiftCounts>['formik'];
  handleOnEditClick: ReturnType<typeof useRegistryGiftCounts>['handleOnEditClick'];
}

export const EditGuestCount = ({ formik, handleOnEditClick }: EditGuestCountProps) => {
  const { t } = useTranslation('sharedComponents');
  const { save } = t('registryGiftCounts');

  return (
    <form onSubmit={formik.handleSubmit}>
      <Flex>
        <StyledFormControl
          __css={styles.formControl}
          isInvalid={!!formik.errors.guestCount}
        >
          <InputV2
            height={pxToRem(38)}
            {...formik.getFieldProps('guestCount')}
          />
        </StyledFormControl>
        <StyledSaveButton
          as="button"
          typographyVariant="button1"
          type="submit"
          __css={styles.saveButton}
          marginRight={2}
        >
          {save()}
        </StyledSaveButton>
        <IconButton
          onClick={handleOnEditClick}
          _hover={styles.cancelHover}
          _active={styles.cancelActive}
          size="md"
          aria-label="cancel"
          borderRadius="100%"
          backgroundColor="transparent"
        >
          <Close
            size="sm"
            color="mono14"
          />
        </IconButton>
      </Flex>
    </form>
  );
};
